import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { GeneralService } from '../general.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UploadModalComponent implements OnInit {
  user: { [key: string]: string } = {};
  proofImg: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Array<string>,
    private s: GeneralService,
    private authServ: AuthService
  ) {
    this.user = JSON.parse(localStorage.getItem('user')!);
  }
  fileName = false;
  readonly dialoRef = inject(MatDialogRef<UploadModalComponent>);

  public files: NgxFileDropEntry[] = [];

  ngOnInit(): void {
    console.log(this.data);
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.s.loader = true;
    setTimeout(() => {
      this.s.loader = false;
    }, 1000);
    this.files = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file);
          this.proofImg = file;
          this.fileName = true;
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  saveUpload() {
    let formData = new FormData();
    formData.append('file', this.proofImg);
  
    // Append each policy_detail_id separately
    this.data.forEach(id => {
      formData.append('policy_detail_ids[]', id);
    });
  
    this.s.uploadPaymentEvidence(formData).subscribe((r) => {
      console.log(r);
      this.s.loader = false;
      this.dialoRef.close();
    });
  }
}
